// extracted by mini-css-extract-plugin
module.exports = {"commonWrapper":"LogOutStub__commonWrapper___Cdlpp","textWrapper":"LogOutStub__textWrapper___2ok7E"};